import { ConnectionWrapper } from "~lib/ConnectionProvider";
import { SyncStage } from "~shared/Connection";

export class CoopPokerConnection extends ConnectionWrapper {
  registerStage(): SyncStage {
    return SyncStage.REGISTER_COOP_POKER;
  }
}
